var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.71,15.29l-1-1-.71-.29h-4l-.71,.29-3.49,3.49-1.21-.61-3.77-3.77-.61-1.21,3.49-3.49,.29-.71V4l-.29-.71-1-1-.71-.29h-2.98l-.7,.29-1.02,1-.3,.71v6l.11,.45,2,4,.19,.26,4,4,.26,.19,4,2,.45,.11h6l.71-.29,1-1,.29-.71v-3l-.29-.71ZM5.27,10.31l-.27-.55V4.42l.43-.42h2.16l.41,.41v3.17l-2.73,2.73Zm14.73,8.27l-.41,.41h-5.35l-.55-.27,2.73-2.73h3.17l.41,.41v2.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/1765206080/media/icon-phone.86ca1b0fffe57093f26f7684b25b4228.svg";
export { ForwardRef as ReactComponent };